import { render, staticRenderFns } from "./icon-phone.vue?vue&type=template&id=2af90d37&"
import script from "./icon-phone.vue?vue&type=script&lang=js&"
export * from "./icon-phone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\MidwestBeltone.Iframes.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2af90d37')) {
      api.createRecord('2af90d37', component.options)
    } else {
      api.reload('2af90d37', component.options)
    }
    module.hot.accept("./icon-phone.vue?vue&type=template&id=2af90d37&", function () {
      api.rerender('2af90d37', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Frontend/vue/icons/icon-phone.vue"
export default component.exports